import {getListCounter} from "~/helpers/common";

export const linkMap = state => {
  const result = {};

  state.convertData.forEach(component => {
    recursiveFindLink(result, component)
  })

  return result;
}

function recursiveFindLink(result, component, parentTxt = '') {
  switch (component.type) {
    case 'section':
    case 'newListItem':
      component.children.forEach(item => recursiveFindLink(result, item, parentTxt))
      break;
    case 'list':
    case 'newList':
      const template = component.pattern.template;
      const type = component.pattern.type;
      component.children.forEach((item, index) => {
        const text = getListCounter(index + 1, type, template)
        const newParentText = `${parentTxt}${text}`
        result[item.id] = newParentText;

        recursiveFindLink(result, item, newParentText)
      })
      break;
    case 'table':
      component.children.map(row => {
        row.items.forEach(cell => {
          if (cell.component && !cell.skip) {
            recursiveFindLink(result, cell.component, parentTxt)
          }
        })
      })
    default:
      break;
  }
}
